import Clients from './Clients'

export const ClientsService = Clients
